import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';
import dateISO from 'src/filters/dateISO';

const query = gql`
query Report($dateFrom: String!, $dateTo: String!, $channelIds: [Int], $requestTypeIds: [Int] ){
  queueReport(dateFrom: $dateFrom, dateTo: $dateTo, channelIds: $channelIds, requestTypeIds: $requestTypeIds) {
    date
    channel
    requestType
    sl
    taskReceived
    taskAbandoned
    taskCompleted
    ccr
    ccrRate
    bcr
    bcrRate
    tocr
    tocrRate
    acr
    acrRate
    fcr
    fcrRate
    arRate
    averageFrt
    averageArt
    asht
    accs
    mccs
  }
}`;

function getQueryReport({
  dateFrom, dateTo, channelIds, requestTypeIds,
}) {
  return apollo.client.query({
    variables: {
      dateFrom: dateISO(dateFrom),
      dateTo: dateISO(dateTo),
      channelIds: channelIds.map((item) => parseInt(item, 10)),
      requestTypeIds: requestTypeIds.map((item) => parseInt(item, 10)),
    },
    query,
    fetchPolicy: 'network-only',
  }).then((res) => res.data.queueReport);
}

export default getQueryReport;
